import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import Image from "../../images/leistungen/herzinsuffizienz.jpg"

const Herzinsuffizienz = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - Herzinsuffizienztherapieoptimierung </h1>
                    <img src={Image} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        Speziell für Patienten mit der Diagnose  <b>Herzinsuffizienz </b>bieten wir neben der optimalen medikamentösen Therapie einen eigenen Nachmittag mit Ernährungsberatung, Bewegungstraining, Raucherentwöhnung, an.
                        <br /><br />
                        Neben der Umsetzung einer an Internationale Richtlinien angelehnten Therapie, berücksichtigen wir das Zusammenspiel zwischen medizinischen und psychosozialen Ursachen .
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Herzinsuffizienz;